import { parseJwt } from "./auth";

const CLAIM = {
  produtoZenPdv: "produto.zenpdv",
  produtoZenTag: "produto.zentag",
  produtoZenGestao: "produto.zengestao",
  produtoZenMobile: "produto.zenmobile",
  produtoZenPass: "produto.zenpass",
};

const DEFAULTS = {
  produtoZenPdv: true,
  produtoZenTag: true,
  produtoZenGestao: true,
  produtoZenMobile: true,
  produtoZenPass: true,
};

/** Mapeia path de licenciamento → chave do produto. */
export const PRODUTO_POR_PATH = [
  { prefix: "/licenciamento/zenpdv", key: "produtoZenPdv" },
  { prefix: "/licenciamento/zentag", key: "produtoZenTag" },
  { prefix: "/licenciamento/zengestao", key: "produtoZenGestao" },
  { prefix: "/licenciamento/zenmobile", key: "produtoZenMobile" },
  { prefix: "/licenciamento/zenpass", key: "produtoZenPass" },
];

export const PRODUTO_POR_SISTEMA = {
  ZenPDV: "produtoZenPdv",
  ZenTag: "produtoZenTag",
  ZenGestao: "produtoZenGestao",
  ZenMobile: "produtoZenMobile",
  ZenPass: "produtoZenPass",
};

function claimToBool(payload, claimType, fallback = true) {
  const raw = payload?.[claimType];
  if (raw === undefined || raw === null || raw === "") return fallback;
  if (typeof raw === "boolean") return raw;
  return String(raw).toLowerCase() === "true";
}

/** Lê produtos ativos das claims do JWT. */
export function getProdutosAtivosFromToken(token) {
  const t = token || sessionStorage.getItem("token");
  const payload = parseJwt(t);
  if (!payload) return { ...DEFAULTS };

  return {
    produtoZenPdv: claimToBool(payload, CLAIM.produtoZenPdv, true),
    produtoZenTag: claimToBool(payload, CLAIM.produtoZenTag, true),
    produtoZenGestao: claimToBool(payload, CLAIM.produtoZenGestao, true),
    produtoZenMobile: claimToBool(payload, CLAIM.produtoZenMobile, true),
    produtoZenPass: claimToBool(payload, CLAIM.produtoZenPass, true),
  };
}

export function getProdutosAtivos() {
  return getProdutosAtivosFromToken();
}

export function isProdutoAtivo(keyOrSistema, token) {
  const produtos = getProdutosAtivosFromToken(token);
  const key = PRODUTO_POR_SISTEMA[keyOrSistema] || keyOrSistema;
  if (!key || !(key in produtos)) return true;
  return !!produtos[key];
}

export function isPathProdutoAtivo(pathname = "", token) {
  const match = PRODUTO_POR_PATH.find(
    (p) => pathname === p.prefix || pathname.startsWith(p.prefix + "/")
  );
  if (!match) return true;
  return isProdutoAtivo(match.key, token);
}

/** Compat: login ainda pode receber flags no body; preferência é o JWT. */
export function persistProdutosAtivos() {
  return getProdutosAtivosFromToken();
}

export function clearProdutosAtivos() {
  // claims vivem no token; nada a limpar além do próprio logout
}
